module.exports = __webpack_public_path__ + "static/accountability-preview-8dede2b47cfe14bc5b4651b515b968f5.jpg";